module.exports = __webpack_public_path__ + "ee46ab9e295c1a848f3cc36e4a2e4c13.fbx";